import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useInviteUserToOrganizationProps, inviteUserToOrganization } from ".";
import { queryKeys } from "@/lib/useQuery/queryKeys";


export function useInviteUserToOrganization() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: queryKeys.organisation._def,
        mutationFn: async (data: useInviteUserToOrganizationProps) => {
            const res = await inviteUserToOrganization(data);
            if (res.error) throw new Error(res.error.message);
            if(res.data.error) throw new Error(res.data.error);
            return res;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.organisation._def, exact: false });
        }
    });
}